import { useTermsAndConditions } from "@/queries/termsAndConditions/useTermsAndConditions";
import TermsAndConditions from "./TermsAndConditions";
import LoadingSection from "@/components/LoadingSection";

export default function TermsPanel() {
  const { data: termsAndConditions, isLoading } = useTermsAndConditions();

  if (isLoading || !termsAndConditions) {
    return <LoadingSection />;
  }
  return (
    <div className="flex flex-col justify-center items-center py-10">
      <TermsAndConditions termsAndConditions={termsAndConditions} />
    </div>
  );
}
